import P5 from 'p5';
import { IScreen } from './iScreen';

class TestScreen implements IScreen{
    song: any;

    constructor(){
        let asset = "/assets/audio/journey";
        let path = `${staticServer}${asset}.mp3`;
        //this.song = p5js.createAudio(path);

        p5js.createAudio(path, (song) => {
            this.song = song;
        });
        
    }   

    setup(){
        
    }

    windowResized(): void {
        
    }

    draw(){
        buffer.background(0);

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.fill(255);
        buffer.textSize(15);
        buffer.noStroke();
        buffer.text("Test Screen", 0, -buffer.height/2+30);
    }

    keyPressed(){
        if(p5js.keyCode === p5js.ESCAPE){
            currentScreen = "mainMenu";
            iScreen = screens[currentScreen];
            //iScreen = new MainMenuScreen(p5js);
            return;
        }
    }

    keyReleased(){
        
    }

    mousePressed(){
        this.song.play();
    }

    mouseReleased(){
        
    }

    touchStarted(){
        
    }

    touchEnded(){
        
    }

    touchMoved(): void {
        
    }

    mouseWheel(event: any): void {
        
    }

}

export default TestScreen;